import { Component, OnInit } from '@angular/core';

@Component({ selector: 'lib-kiene-core', template: ` <p>kiene-core works!</p> `, styles: [] })
export class KieneCoreComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
